$(document).ready(function () {
    let videoBlock = document.querySelector('.researchers-video .video');
    if (videoBlock === null) return;

    let videoButton = videoBlock.querySelector('.play');
    let videoImage = videoBlock.querySelector('img');
    let videoIframe = document.querySelector('.video .video-iframe');

    videoButton.addEventListener('click', function (event) {
        event.preventDefault();

        videoButton.remove();
        videoImage.style.opacity = 0;
        videoIframe.style.display = 'block';
        videoBlock.classList.add('active');
        let iframe = document.querySelector('.video-iframe');
        let iframeId = iframe.getAttribute('id');
        let videoSrc = iframe.getAttribute('data-src');
        new YT.Player(iframeId, {
            videoId: '' + videoSrc + '',
            playerVars: {
                rel: '0'
            },
            events: {
                'onReady': function (event) {
                    event.target.playVideo();
                }
            }
        });
    });
});
